import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import Modal from "@/components/Modal.vue";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
// @ts-ignore
import Datepicker from "vuejs-datepicker";
// @ts-ignore
require("vue2-animate/dist/vue2-animate.min.css");
let MonthlySummary = class MonthlySummary extends Vue {
    shortenUsername(name) {
        if (name.length > 14) {
            return name.substring(0, 12) + "..";
        }
        else {
            return name;
        }
    }
    getShortMonth(value) {
        if (value !== undefined && value !== null) {
            return value.substring(0, 3);
        }
    }
    selectPreviousMonth() {
        const newDate = moment(this.$store.getters.getSelectedDate).subtract(1, "month");
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
            onlyDate: true,
        });
        this.getDateInfo();
        this.loadStakeholderReports();
    }
    selectNextMonth() {
        const newDate = moment(this.$store.getters.getSelectedDate).add(1, "month");
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
            onlyDate: true,
        });
        this.getDateInfo();
        this.loadStakeholderReports();
    }
    getCustomersFromStakeholderReports() {
        const stakeholderReports = this.$data.stakeholderReports;
        const tempCustomers = [];
        if (stakeholderReports !== undefined && stakeholderReports !== null) {
            stakeholderReports.forEach((report) => {
                let found = false;
                tempCustomers.forEach((existingCustomer) => {
                    if (existingCustomer === report.customer) {
                        found = true;
                    }
                });
                if (found === false) {
                    const tempCustomer = report.customer;
                    tempCustomers.push(tempCustomer);
                }
            });
            //this.$data.customerList = tempCustomers;
            return tempCustomers;
        }
    }
    async downloadStakeholderReportCSV() {
        try {
            this.$data.loading = true;
            const result = await this.$store.dispatch("downloadStakeholderReportsCSV", { date: this.$store.getters.getSelectedDate });
            const downloadLink = document.createElement("a");
            downloadLink.href = result.headers.location;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
        catch (err) {
            window.errorHandler.logError(err, "Overview.vue -> downloadStakeholderReportCSV");
        }
        finally {
            this.$data.loading = false;
        }
    }
    getTariffsFromReports(reports) {
        const stakeholderReports = reports;
        const tempTariffs = [];
        if (stakeholderReports !== undefined && stakeholderReports !== null) {
            stakeholderReports.forEach((report) => {
                let found = false;
                tempTariffs.forEach((existingTariff) => {
                    if (existingTariff === report.tariff) {
                        found = true;
                    }
                });
                if (found === false) {
                    const tempTariff = report.tariff;
                    tempTariffs.push(tempTariff);
                }
            });
            //this.$data.tariffList = tempTariffs;
            return tempTariffs;
        }
    }
    getReportsFromCustomer(customer) {
        let tempList = [];
        tempList = this.$data.stakeholderReports.filter((object) => object.customer === customer); // save the sorted list
        return tempList;
    }
    getReportsFromTariff(tariff) {
        let tempList = [];
        tempList = this.$data.stakeholderReports.filter((object) => object.tariff === tariff); // save the sorted list
        return tempList;
    }
    calculateTotalHours(array) {
        let totalHours = 0;
        if (array !== null) {
            array.forEach((report) => {
                totalHours += report.hours;
            });
        }
        return totalHours;
    }
    loadStakeholderReports() {
        const first = moment(this.$store.getters.getSelectedDate).startOf("month");
        const last = moment(this.$store.getters.getSelectedDate).endOf("month");
        if (first !== moment(this.$data.month.start)) {
            const startTimeString = moment(first).format("YYYY-MM-DD 00:00");
            const endTimeString = moment(last).format("YYYY-MM-DD 23:59");
            const reportObject = {
                from: startTimeString,
                to: endTimeString,
            };
            this.$store.dispatch("getStakeholderReports", reportObject);
            this.$data.loaders.stakeholderReports = true; // set loader to true;
        }
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
    getDay(date) {
        return moment(date).format("ddd");
    }
    shortDate(date) {
        return moment(date).format("YYYY-MM-DD");
    }
    getWeek(date) {
        return moment(date).format("WW");
    }
    shortDay(dayName) {
        if (dayName !== undefined && dayName !== "") {
            return dayName.substring(0, 1);
        }
        else {
            return "";
        }
    }
};
MonthlySummary = __decorate([
    Component({
        data() {
            return {
                theme: this.$store.getters.getTheme,
                stakeholderReports: null,
                user: "",
                totalWorkedHours: 0,
                customerList: null,
                sortbyValue: "date",
                headers: [
                    { text: "Week", value: "week" },
                    { text: "Date", value: "date" },
                    { text: "Day", value: "day" },
                    { text: "Name", value: "name" },
                    { text: "Hours", value: "hours" },
                ],
                fields: [
                    {
                        key: "tariff",
                    },
                    {
                        key: "name",
                        sortable: false,
                    },
                    {
                        key: "date",
                        sortable: true,
                    },
                    {
                        key: "hours",
                        sortable: true,
                    },
                    {
                        key: "comment",
                    },
                ],
                filter: "",
                selectedDate: this.$store.getters.getSelectedDate,
                dateInfo: {
                    year: 0,
                    month: null,
                    week: 0,
                    weekHours: 0,
                    monthHours: 0,
                },
                loaders: { stakeholderReports: false },
                month: { month: "", year: "" },
            };
        },
        mounted() {
            this.getDateInfo();
            this.loadStakeholderReports();
            //this.loadTariffs();
            this.$store.commit("setSelectedDate", { date: new Date(), onlyDate: true });
            this.$data.dateInfo = this.$store.getters.getDateInfo;
            // loading the reports for the barchart
            window.eventBus.$on("stakeholderReportsLoaded", (obj) => {
                this.$data.dateInfo = this.$store.getters.getDateInfo;
                this.$data.stakeholderReports = obj;
                this.$data.loaders.stakeholderReports = false;
                this.$data.totalWorkedHours = this.calculateTotalHours(obj);
                this.$data.user = this.$store.getters.getTokenProfile.name;
            });
        },
        components: {
            Modal,
            Datepicker,
            IconBox,
            IconBoxContent,
            WhiteBox,
        },
    })
], MonthlySummary);
export default MonthlySummary;
